// extracted by mini-css-extract-plugin
export default {"RecoveryPasswordPage":"RecoveryPassword_RecoveryPasswordPage__tWkfA","RecoveryPasswordPage__body":"RecoveryPassword_RecoveryPasswordPage__body__3jbJu"};